// extracted by mini-css-extract-plugin
module.exports = {"project-title":"Header_project-title__9G-p-","search":"Header_search__3X-z6"};